.background {
  background: var(--dds-paper-background);
}
.border {
  border: 1px solid var(--dds-paper-border);
}

:where(.container) {
  box-sizing: border-box;
  background-color: var(--dds-color-surface-default);
  border-radius: var(--dds-border-radius-surface);
  margin: 0;
}

:where(.shadow--small) {
  box-shadow: var(--dds-shadow-small);
}
:where(.shadow--medium) {
  box-shadow: var(--dds-shadow-medium);
}
:where(.shadow--large) {
  box-shadow: var(--dds-shadow-large);
}

:where(.border-radius--button) {
  border-radius: var(--dds-border-radius-button);
}

:where(.border-radius--surface) {
  border-radius: var(--dds-border-radius-surface);
}

:where(.border-radius--chip) {
  border-radius: var(--dds-border-radius-chip);
}

:where(.border-radius--input) {
  border-radius: var(--dds-border-radius-input);
}

:where(.border-radius--rounded) {
  border-radius: var(--dds-border-radius-rounded);
}

:where(.border-radius--0) {
  border-radius: 0;
}
